import React, { useState, FC } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  TextField,
  Button,
  Typography,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

interface GradingChild {
  id: number;
  name?: string;
  gradingGuideline: string | null;
  children?: GradingChild[];
}

interface Rubric {
  id: number;
  name?: string;
  children: any[];
  maxMarks: number;
}

interface EditableJsonProps {
  initialJson: Rubric;
  saveRubrics: (rubric: Rubric) => void;
  isSubmitting: boolean;
  isPublished?: boolean;
}

// Component for editable JSON structure
const EditableJson: FC<EditableJsonProps> = ({
  initialJson,
  saveRubrics,
  isSubmitting,
  isPublished,
}) => {
  const [json, setJson] = useState<Rubric>(initialJson);

  const updateJsonAtPath = (path: number[], newValue: string | null) => {
    setJson((prevJson) => {
      const newJson = structuredClone(prevJson);
      let current = newJson;
      path.forEach((key, idx) => {
        if (idx === path.length - 1) {
          current.children![key].gradingGuideline = newValue;
        } else {
          current = current.children![key];
        }
      });
      return newJson;
    });
  };

  const renderNestedFields = (children: GradingChild[]=[], path: number[] = []) =>
    children.map((child, idx) => {
      const currentPath = [...path, idx];
      const levelLabel = `L${currentPath.length}`;

      return (
        <Accordion key={child.id}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Box
              justifyContent={"space-between"}
              alignItems={"center"}
              display={"flex"}
              width={"100%"}
            >
              <Typography pr={2}>
                {child.name}
                <Typography fontWeight={700}>ID: {child.id}</Typography>
              </Typography>
              <Typography variant="caption">{levelLabel}</Typography>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            {child.gradingGuideline !== null && (
              <TextField
                label="Grading Guidelines"
                variant="outlined"
                fullWidth
                multiline
                value={child.gradingGuideline || ""}
                onChange={(e) => updateJsonAtPath(currentPath, e.target.value)}
                sx={{ mb: 2 }}
              />
            )}
            {Array.isArray(child.children) &&
              renderNestedFields(child.children, currentPath)}
          </AccordionDetails>
        </Accordion>
      );
    });

  return (
    <div>
      {/* <Typography variant="h4" gutterBottom>
        Editable Rubric Structure
      </Typography> */}
      <Box height={"40vh"} overflow={"auto"}>
        {renderNestedFields(json.children)}
      </Box>
      <Box display={"flex"} justifyContent={"flex-end"}>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => saveRubrics(json)}
          disabled={isSubmitting || isPublished}
          sx={{ mt: 2 }}
        >
          Save
        </Button>
      </Box>
    </div>
  );
};

export default EditableJson;
